import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "usdEvent"
  }, [_c('div', {
    staticClass: "usdEvent-main"
  }, [_c('div', {
    staticClass: "usdEvent-bg",
    style: {
      background: `url(${require('@images/tapcoin/task-detail-bg.jpg')}) center top/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "usdEvent-banner"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/lucky/usdEventBanner.jpg'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "usdEvent-box"
  }, [_c('div', {
    staticClass: "usdEvent-income"
  }, [_c('div', {
    staticClass: "usdEvent-income__title"
  }, [_vm._v("My Income")]), _c('div', {
    staticClass: "usdEvent-income__total"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/USDT-small.png`),
      "alt": ""
    }
  }), _vm._v(_vm._s(_vm._f("fmt_usdtPre")(_vm.balance.usdt.balance)))])]), _c('div', {
    staticClass: "usdEvent-btns"
  }, [_c('div', {
    staticClass: "usdEvent-btn",
    on: {
      "click": () => _vm.$router.push('/usdLucky')
    }
  }, [_vm._v("Free Collection "), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/USDT-small.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "usdEvent-btn",
    on: {
      "click": () => _vm.$router.push('/withdraw?cid=ton&id=1')
    }
  }, [_vm._v("Withdraw")])]), _c('div', {
    staticClass: "usdEvent-activity"
  }, [_c('div', {
    staticClass: "usdEvent-activity-title"
  }, [_c('span', [_vm._v("Withdrawal Activity ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require(`@images/tapcoin/proof.jpg`)
    },
    on: {
      "click": _vm.jumpTo
    }
  })]), _c('div', {
    staticClass: "usdEvent-activity-main"
  }, [_c('transition-group', {
    staticClass: "usdEvent-activity-list",
    attrs: {
      "tag": "div",
      "name": "blocks"
    },
    on: {
      "enter": _vm.blocksEnter,
      "leave": _vm.blocksLeave
    }
  }, _vm._l(_vm.activityList, function (item, index) {
    return _c('div', {
      key: `s${index}`,
      staticClass: "usdEvent-activity-item",
      class: index === 0 && _vm.isActivityAnim && 'active',
      attrs: {
        "data-index": index + 1
      }
    }, [_c('div', {
      staticClass: "usdEvent-activity__head"
    }, [_c('m-head', {
      attrs: {
        "name": item,
        "bgColor": item.head_color,
        "fontSize": "13",
        "size": "30"
      }
    })], 1), _c('div', {
      staticClass: "usdEvent-activity-info"
    }, [_c('div', {
      staticClass: "usdEvent-activity-info__name"
    }, [_vm._v(_vm._s(item.firstname) + " " + _vm._s(item.lastname))]), _c('div', {
      staticClass: "usdEvent-activity-info__address"
    }, [_vm._v(_vm._s(item.to_address))])]), _c('div', {
      staticClass: "usdEvent-activity__price"
    }, [_vm._v("+" + _vm._s(_vm._f("fmt_usdtPre")(item.amount)) + " "), _c('img', {
      attrs: {
        "src": require(`@images/tapcoin/new/USDT-small.png`),
        "alt": ""
      }
    })])]);
  }), 0)], 1)])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };